import reducers from './reducers';

export {
    actions as productsAttributesOperations,
    default as productsAttributesSaga,
} from './operations';

export default reducers;
